import { render } from "./ASkeletonLoader.vue?vue&type=template&id=78e18b16"
import script from "./ASkeletonLoader.vue?vue&type=script&lang=js"
export * from "./ASkeletonLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__